import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OidcService } from '../core/oidc/oidc.service';

@Injectable()
export class NMDPAuthInterceptor implements HttpInterceptor {

  constructor(private oidcService: OidcService) {}

  private isJwtToken(token: string): boolean {
    if (!token || typeof token !== 'string') return false;
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    try {
      const header = JSON.parse(atob(parts[0]));
      return header.alg && header.typ === 'JWT';
    } catch {
      return false;
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip OIDC during EHR flows only
    const { href: url, search } = window.location;
    const urlParams = new URLSearchParams(search);
    const code = urlParams.get('code');
    const isEhrFlow = url.includes('iss=') || url.includes('launch=') || 
                     (code && this.isJwtToken(code));
    
    if (isEhrFlow) {
      console.log('EHR flow detected, bypassing OIDC completely');
      return next.handle(req);
    }
    
    // Use cached OIDC token for non-EHR flows only
    const token = this.oidcService.accessToken;
    if (token && req.url.includes('nmdp.org')) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}